import { DatePipe, JsonPipe } from '@angular/common';
import { Component, Input, OnInit, WritableSignal, inject, signal } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatTableModule } from '@angular/material/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AgeStringPipe } from '../../../pipes/age-string.pipe';
import { AssessmentNotesPipe } from '../../../pipes/assessment-notes.pipe';
import { GenderStringPipe } from '../../../pipes/gender-string.pipe';
import { MonthStringPipe } from '../../../pipes/month-string.pipe';
import { AssessmentsService } from '../../../services/assessments.service';
import { Assessment, IcfCategory, Patient, ReportItem, icfCategoryLabels } from '../../../services/model';
import { PatientsService } from '../../../services/patients.service';
import { ReportRowComponent } from './report-row/report-row.component';
import { SideStringPipe } from '../../../pipes/side-string.pipe';

@Component({
  selector: 'app-report',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCardModule,
    ReactiveFormsModule,
    JsonPipe,
    MatTableModule,
    MonthStringPipe,
    GenderStringPipe,
    AgeStringPipe,
    SideStringPipe,
    DatePipe,
    AssessmentNotesPipe,
    MatIconModule,
    RouterModule,
    ReportRowComponent,
  ],
  templateUrl: './report.component.html',
  styleUrl: './report.component.scss',
})
export class ReportComponent implements OnInit {
  @Input() patientId?: string;
  patient: WritableSignal<Patient | undefined> = signal(undefined);
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private assessmentsService: AssessmentsService = inject(AssessmentsService);
  private patientsService: PatientsService = inject(PatientsService);

  icfCategoryLabels: { [key in IcfCategory]: string } = icfCategoryLabels;
  reportList: WritableSignal<ReportItem[] | undefined> = this.assessmentsService.reportList;

  tableColumns = ['date', 'type', 'score', 'note', 'buttons'];

  constructor() {}

  ngOnInit(): void {
    console.log('patientID', this.patientId);
    if (this.patientId !== undefined) {
      this.patientsService.getPatient(this.patientId).then(patient => {
        this.patient.set(patient);
        this.assessmentsService.getAssessments();
      });
    }
  }

  newAssessment() {
    this.router.navigate(['../../assessments/new'], { relativeTo: this.route });
  }

  navigateToAssessment(assessment: Assessment) {
    console.log('ass', assessment);
    if (assessment) {
      this.router.navigate(['../../assessments/' + assessment.type.toLowerCase() + '/' + assessment._documentId], {
        relativeTo: this.route,
      });
    }
  }

  deleteAssessment(assessment: Assessment) {
    if (assessment?._documentId) {
      this.assessmentsService.deleteAssessment(assessment._documentId);
    }
  }

  print() {
    window.print();
  }
}
